import { Col, List, Row, Spin, Typography } from "antd";
import { Content } from "antd/lib/layout/layout";
import { useCallback, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { StockLevel } from "../../assets/images";
import Loadingtext from "../../components/loading";
import NoRecordFound from "../../components/NoRecordFound";
import Releases from "../../components/releases";
import { setLoading } from "../../store/common/commonActions";
import {
  storeProductReleaseEnumValue,
  storeSearchCount,
  storeSearchData,
} from "../../store/products/productsActions";
import { exportSearchData, getExportproducts, SearchData } from "../../store/products/productsAsyncActions";
import { imageUrl } from "../../utils/functions";
import Localize from "../../utils/string";
import Papa from "papaparse";

const SearchItem = () => {
  const Location = useLocation();
  const searchData = useSelector((state: any) => state.products.searchData);
  const searchProductCount = useSelector(
    (state: any) => state.products.searchDataCount
  );
  const Loading = useSelector((state: any) => state.common.loading);
  const [newLoading,setNewLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [startIndex, setStartIndex] = useState(0 as number);
  const [recordCount, setRecordCount] = useState(10 as number);
  const [MoreData, setMoreData] = useState(false);
  const [SearchingItem, setSearchingItem] = useState("");
  const loginResp = useSelector((state: any) => state.user.userSession);
  const [isExport, setIsExport] = useState<boolean>(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const queryParams: any = new URLSearchParams(Location.search);
    if (queryParams !== null) {
      scrollToTop();
      const searchingItem = queryParams.get("searchItem") ?? "";

      if (searchingItem) {
        setSearchingItem(searchingItem);
        dispatch(storeSearchData([], false));
        dispatch(storeSearchCount(0));
        dispatch(setLoading(true));
        setIsExport(false)
        setStartIndex(1);
      }
    }
  }, [Location.search]);

  const handleClick = () => {
    dispatch(storeProductReleaseEnumValue(null));
  };

  useEffect(() => {
    scrollToTop();
    setStartIndex(1);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const initialFunction: any = useCallback(async () => {
    if (SearchingItem) {
      setNewLoading(true);
      const value = SearchingItem.replace("&", "%26");
      let cId = loginResp?.userId ?? 0;
      const query = `?startIndex=${startIndex}&pageSize=16&searchBy=${value}&customerId=${cId}`;
      // const response: any = await dispatch(
      //   getproducts(Qparams, MoreData, setMoreData)
      // );

      await dispatch(SearchData(query, MoreData, setMoreData));
      setNewLoading(false);
    }
    if (startIndex < recordCount) {
      setHasMore(true);
    }
  }, [
    dispatch,
    startIndex,
    SearchingItem,
    //  genericId, formatName, labelId
  ]);
  useEffect(() => {
    initialFunction();
    // ;
  }, [initialFunction]);


  const getExportDataRelease = async () => {
    setIsExport(true);
    const queryString = window.location.search;
    const all_products: any[] = [];
    let Qparams = `?`;

    if (SearchingItem) {
      const value = SearchingItem.replace("&", "%26");
      let cId = loginResp?.userId ?? 0;
      Qparams += `searchBy=${value}&customerId=${cId}&isSearchProduct=${1}`;
    }

    const response: any = await dispatch(getExportproducts(Qparams,setIsExport));
    const products = response?.ExportData;
    products.forEach((product: any) => {
      const newArray = product.genreNames?.map((elem: any) =>
        elem?.name.trim()
      );
      const lists: any = newArray?.join(`,\xa0`);
      const featuringName = `${product.featuredArtistName_1 != null ? product.featuredArtistName_1 : ""
        }${product.featuredArtistName_2 != null
          ? ` / ${product.featuredArtistName_2}`
          : ""
        }${product.featuredArtistName_3 != null
          ? ` / ${product.featuredArtistName_3}`
          : ""
        }${product.featuredArtistName_4 != null
          ? ` / ${product.featuredArtistName_4}`
          : ""
        }`;
      const obj = {
        cartNo: product?.catNo,
        releaseName: product.title,
        artist: `${product?.artistName}${product?.artistName_2 != null ? ` / ${product?.artistName_2}` : ""
          }${product?.artistName_3 != null ? ` / ${product?.artistName_3}` : ""}${product?.artistName_4 != null ? ` / ${product?.artistName_4}` : ""
          }${featuringName !== "" ? ` Featuring ${featuringName}` : ""}`,
          labelNames: (product?.secondary_labelname && product?.secondary_labelname?.toUpperCase()) ?? (product?.labels?.name && product?.labels?.name?.toUpperCase()) ?? Localize.LabelNotAvailable,
        format: product?.format,
        unitPrice: formatCurrency(product?.sellPrice),
        genres: lists,
        link: `${window.location.origin}/products/${product.productType}/${product.catNo}`,
      };
      all_products.push(obj);
    });
    generateCSV(all_products);
  };

  const formatCurrency = (amountString: string, currencySymbol = "£") => {
    const amount = parseFloat(amountString);
    if (isNaN(amount)) {
      return "Invalid amount";
    }
    // Format the number without the currency symbol
    const formattedAmount = new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
    // Manually prepend the currency symbol
    return `${currencySymbol}${formattedAmount}`;
  };

  const generateCSV = (products: any[]) => {
    // Use PapaParse to convert the products array to CSV
    const headers = [
      { label: "Cat", key: "cartNo" },
      { label: "Artist(s)", key: "artist" },
      { label: "Title", key: "releaseName" },
      { label: "Label(s)", key: "labelNames" },
      { label: "Format", key: "format" },
      { label: "Genres", key: "genres" },
      { label: "Unit Price", key: "unitPrice" },
      { label: "Release Page", key: "link" },
    ];
    const csv = '\ufeff' + Papa.unparse({
      fields: headers.map((header) => header.label),
      data: products.map((product) =>
        headers.map((header) => {
          let value = product[header.key];
          value = value.replace(/;/g, ',');
          return value;
        })
      ),
    }, { quotes: true, });

    // Trigger download
    downloadCSV(csv);
  };
  const downloadCSV = (csv: string) => {
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "releases.csv"; // Set the default filename for download
    a.click();
    URL.revokeObjectURL(url);
    setIsExport(false);
  };

  const loadDataOnScroll = async (page = 1) => {
    if (startIndex + 1 > recordCount) {
      setMoreData(false);
      setHasMore(false);
    } else {
      setHasMore(false);
      setMoreData(true);
      setStartIndex(startIndex + 1);
    }
  };

  useEffect(() => {
    if (startIndex < recordCount) {
      setHasMore(true);
    }
  }, [recordCount]);
  useEffect(() => {
    setRecordCount(searchProductCount / 16);
  }, [searchProductCount]);

  enum PageActions {
    PREVIOUS = "PREVIOUS",
    NEXT = "NEXT",
  }

  const loadMoreData = (
    pageNumber: number,
    action: PageActions = PageActions.NEXT
  ) => {
    scrollToTop();
    dispatch(setLoading(true));
    if (pageNumber !== 0) {
      setStartIndex(pageNumber);
      return;
    }
    const pageNo =
      action === PageActions.NEXT ? startIndex + 1 : startIndex - 1;
    setStartIndex(pageNo);
  };

  const generatePagination = () => {
    const pages: any = [];
    const totalcount = Math.ceil(recordCount);
    const currentPage = startIndex;
    if (totalcount <= 6) {
      for (let i = 1; i <= totalcount; i++) {
        pages.push(i);
      }
      return pages;
    } else {
      // Always print first page button
      pages.push(1);

      // Print "..." only if currentPage is > 3
      if (currentPage > 3) {
        pages.push("...");
      }

      // special case where last page is selected...
      if (currentPage === totalcount) {
        pages.push(currentPage - 2);
      }

      // Print previous number button if currentPage > 2
      if (currentPage > 2) {
        pages.push(currentPage - 1);
      }

      //Print current page number button as long as it not the first or last page
      if (currentPage !== 1 && currentPage !== totalcount) {
        pages.push(currentPage);
      }

      //print next number button if currentPage < lastPage - 1
      if (currentPage < totalcount - 1) {
        pages.push(currentPage + 1);
      }

      // special case where first page is selected...
      if (currentPage === 1) {
        pages.push(currentPage + 2);
      }

      //print "..." if currentPage is < lastPage -2
      if (currentPage < totalcount - 2) {
        pages.push("...");
      }

      pages.push(totalcount);
      return pages;
    }
  };

  const pagesToShow = generatePagination();
  return (
    <div className="releases-section search">
      <div className="container">
        <Row>
          <Col sm={24} className="full-width-100">
            <Content className="releases">
              <div className="container fixed-container">
                {newLoading ? (
                  <Loadingtext />
                ) : (
                  <>
                    <List
                      className="main-releases-listing"
                      dataSource={searchProductCount !== 0 ? searchData : []}
                      locale={{ emptyText: <NoRecordFound /> }}
                      renderItem={(item: any) => (
                        <List.Item onClick={() => handleClick()}>
                          <Releases
                            image={imageUrl(
                              item?.productType?.name,
                              item?.catNo
                            )}
                            title={item.title || Localize.TitleNotAvailable}
                            labelName={
                              item?.secondary_labelname ||
                              item?.labels?.name ||
                              Localize.LabelNotAvailable
                            }
                            desc={
                              item?.shortDescription ||
                              Localize.DescriptionNotAvailable
                            }
                            productId={item?.id}
                            artistName={
                              item?.artists?.name || Localize.ArtistNotAvailable
                            }
                            catNo={item?.catNo}
                            forthComing={item.isForthcoming || false}
                            isRsdSpecial={item.isRsdSpecial || false}
                            productType={item?.productType?.name}
                            stockDescription={
                              <>
                                {/* <Typography.Title
                                      level={4}
                                      className="remaining-stock"
                                    >
                                      REMAINING STOCK - <StockLevel />
                                    </Typography.Title> */}
                              </>
                            }
                          />
                        </List.Item>
                      )}
                    />
                    {/* <div className="pagination-export-wrapper">
                      {recordCount !== 0 && (
                        <div className="pagination-wrapper">
                          <div className="page-numbers">
                            <button
                              className="action"
                              disabled={startIndex <= 1}
                              onClick={() => {
                                loadMoreData(0, PageActions.PREVIOUS);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                              >
                                <g
                                  id="Group_408"
                                  data-name="Group 408"
                                  transform="translate(-531.075 -1871.245)"
                                >
                                  <g
                                    id="Group_289"
                                    data-name="Group 289"
                                    transform="translate(540.916 1881.206)"
                                  >
                                    <path
                                      id="Path_13"
                                      data-name="Path 13"
                                      d="M6838.1-345.471l-7.578-7.578,7.578-7.578"
                                      transform="translate(-6830.525 360.628)"
                                      fill="none"
                                      stroke="#141414"
                                      stroke-width="1"
                                    />
                                    <line
                                      id="Line_7"
                                      data-name="Line 7"
                                      x2="14.597"
                                      transform="translate(0.375 7.348)"
                                      fill="none"
                                      stroke="#141414"
                                      stroke-width="1"
                                    />
                                  </g>
                                  <g
                                    id="Ellipse_57"
                                    data-name="Ellipse 57"
                                    transform="translate(565.075 1905.245) rotate(180)"
                                    fill="none"
                                    stroke="#1f1f1f"
                                    stroke-width="1"
                                  >
                                    <circle
                                      cx="17"
                                      cy="17"
                                      r="17"
                                      stroke="none"
                                    />
                                    <circle
                                      cx="17"
                                      cy="17"
                                      r="16.5"
                                      fill="none"
                                    />
                                  </g>
                                </g>
                              </svg>
                            </button>
                            {pagesToShow &&
                              pagesToShow.map((page: any, index: any) =>
                                page === "..." ? (
                                  <div className="dashes">
                                    <div className="dash">.</div>
                                    <div className="dash">.</div>
                                    <div className="dash">.</div>
                                    <div className="dash">.</div>
                                    <div className="dash">.</div>
                                    <div className="dash">.</div>
                                  </div>
                                ) : (
                                  <div
                                    key={index}
                                    className={`page ${
                                      startIndex === page ? "active" : ""
                                    }`}
                                    onClick={() => loadMoreData(page)}
                                  >
                                    {page}
                                  </div>
                                )
                              )}
                            <button
                              disabled={recordCount <= startIndex}
                              className="action"
                              onClick={() => {
                                loadMoreData(0, PageActions.NEXT);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                              >
                                <g
                                  id="Group_407"
                                  data-name="Group 407"
                                  transform="translate(-859.075 -1871.245)"
                                >
                                  <g
                                    id="Group_280"
                                    data-name="Group 280"
                                    transform="translate(883.234 1895.285) rotate(180)"
                                  >
                                    <path
                                      id="Path_13"
                                      data-name="Path 13"
                                      d="M7.578,15.156,0,7.578,7.578,0"
                                      transform="translate(0 0)"
                                      fill="none"
                                      stroke="#141414"
                                      stroke-width="1"
                                    />
                                    <line
                                      id="Line_7"
                                      data-name="Line 7"
                                      x2="14.597"
                                      transform="translate(0.375 7.348)"
                                      fill="none"
                                      stroke="#141414"
                                      stroke-width="1"
                                    />
                                  </g>
                                  <g
                                    id="Ellipse_56"
                                    data-name="Ellipse 56"
                                    transform="translate(859.075 1871.245)"
                                    fill="none"
                                    stroke="#1f1f1f"
                                    stroke-width="1"
                                  >
                                    <circle
                                      cx="17"
                                      cy="17"
                                      r="17"
                                      stroke="none"
                                    />
                                    <circle
                                      cx="17"
                                      cy="17"
                                      r="16.5"
                                      fill="none"
                                    />
                                  </g>
                                </g>
                              </svg>
                            </button>
                          </div>
                        </div>
                      )}
                      {searchData.length > 0 && loginResp && (
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (!loginResp) return;
                            if (isExport) return;
                            getExportDataRelease();
                          }}
                          className="export-button"
                        >
                          <span>{isExport ? 'Exporting...' : 'Export'}</span>
                        </button>
                      )}
                    </div> */}
                    {/* {MoreData && <Spin tip="Loading..."></Spin>} */}
                    {/* {!(startIndex + 1 > recordCount) && <Spin tip="Loading..."></Spin>} */}
                  </>
                )}
                <div className="pagination-export-wrapper">
                  {recordCount !== 0 && (
                    <div className="pagination-wrapper">
                      <div className="page-numbers">
                        <button
                          className="action"
                          disabled={startIndex <= 1}
                          onClick={() => {
                            loadMoreData(0, PageActions.PREVIOUS);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                          >
                            <g
                              id="Group_408"
                              data-name="Group 408"
                              transform="translate(-531.075 -1871.245)"
                            >
                              <g
                                id="Group_289"
                                data-name="Group 289"
                                transform="translate(540.916 1881.206)"
                              >
                                <path
                                  id="Path_13"
                                  data-name="Path 13"
                                  d="M6838.1-345.471l-7.578-7.578,7.578-7.578"
                                  transform="translate(-6830.525 360.628)"
                                  fill="none"
                                  stroke="#141414"
                                  stroke-width="1"
                                />
                                <line
                                  id="Line_7"
                                  data-name="Line 7"
                                  x2="14.597"
                                  transform="translate(0.375 7.348)"
                                  fill="none"
                                  stroke="#141414"
                                  stroke-width="1"
                                />
                              </g>
                              <g
                                id="Ellipse_57"
                                data-name="Ellipse 57"
                                transform="translate(565.075 1905.245) rotate(180)"
                                fill="none"
                                stroke="#1f1f1f"
                                stroke-width="1"
                              >
                                <circle
                                  cx="17"
                                  cy="17"
                                  r="17"
                                  stroke="none"
                                />
                                <circle
                                  cx="17"
                                  cy="17"
                                  r="16.5"
                                  fill="none"
                                />
                              </g>
                            </g>
                          </svg>
                        </button>
                        {pagesToShow &&
                          pagesToShow.map((page: any, index: any) =>
                            page === "..." ? (
                              <div className="dashes">
                                <div className="dash">.</div>
                                <div className="dash">.</div>
                                <div className="dash">.</div>
                                <div className="dash">.</div>
                                <div className="dash">.</div>
                                <div className="dash">.</div>
                              </div>
                            ) : (
                              <div
                                key={index}
                                className={`page ${startIndex === page ? "active" : ""
                                  }`}
                                onClick={() => loadMoreData(page)}
                              >
                                {page}
                              </div>
                            )
                          )}
                        <button
                          disabled={recordCount <= startIndex}
                          className="action"
                          onClick={() => {
                            loadMoreData(0, PageActions.NEXT);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                          >
                            <g
                              id="Group_407"
                              data-name="Group 407"
                              transform="translate(-859.075 -1871.245)"
                            >
                              <g
                                id="Group_280"
                                data-name="Group 280"
                                transform="translate(883.234 1895.285) rotate(180)"
                              >
                                <path
                                  id="Path_13"
                                  data-name="Path 13"
                                  d="M7.578,15.156,0,7.578,7.578,0"
                                  transform="translate(0 0)"
                                  fill="none"
                                  stroke="#141414"
                                  stroke-width="1"
                                />
                                <line
                                  id="Line_7"
                                  data-name="Line 7"
                                  x2="14.597"
                                  transform="translate(0.375 7.348)"
                                  fill="none"
                                  stroke="#141414"
                                  stroke-width="1"
                                />
                              </g>
                              <g
                                id="Ellipse_56"
                                data-name="Ellipse 56"
                                transform="translate(859.075 1871.245)"
                                fill="none"
                                stroke="#1f1f1f"
                                stroke-width="1"
                              >
                                <circle
                                  cx="17"
                                  cy="17"
                                  r="17"
                                  stroke="none"
                                />
                                <circle
                                  cx="17"
                                  cy="17"
                                  r="16.5"
                                  fill="none"
                                />
                              </g>
                            </g>
                          </svg>
                        </button>
                      </div>
                    </div>
                  )}
                  {searchData.length > 0 && loginResp && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (!loginResp) return;
                        if (isExport) return;
                        getExportDataRelease();
                      }}
                      className={`export-button ${Loading ? 'button-disable' : ''}`}
                    >
                      <span>{isExport ? 'Exporting...' : 'Export'}</span>
                    </button>
                  )}
                </div>

                {/* )} */}
              </div>
            </Content>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default SearchItem;
